import type { DiffSummary } from '../form/formDiff';

export interface SummaryPart {
    key: string;
    count?: number;
}

/** The parts of "2 pens changed, credentials replaced", as copy keys with their counts. */
export function summaryParts(summary: DiffSummary): SummaryPart[] {
    const changed = summary.pensChanged - summary.created - summary.removed;
    const parts: SummaryPart[] = [];
    if (changed > 0) parts.push({ key: 'providerConfig.save.pensChanged', count: changed });
    if (summary.created > 0)
        parts.push({ key: 'providerConfig.save.created', count: summary.created });
    if (summary.removed > 0)
        parts.push({ key: 'providerConfig.save.removed', count: summary.removed });
    if (summary.connectionChanged) parts.push({ key: 'providerConfig.save.connectionChanged' });
    if (summary.credentialsReplaced) parts.push({ key: 'providerConfig.save.credentialsReplaced' });
    if (summary.credentialsSet) parts.push({ key: 'providerConfig.save.credentialsSet' });
    if (summary.credentialsCleared) parts.push({ key: 'providerConfig.save.credentialsCleared' });
    return parts;
}
